import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/auth.css';

const Unauthorized = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (err) {
      console.error('Logout error:', err);
    }
  };

  return (
    <div className="auth-page-wrapper">
      <div className="auth-panel glass-panel" style={{ textAlign: 'center' }}>
        <div className="auth-header">
          <h2 style={{ color: '#ef4444' }}>Access Denied</h2>
          <p style={{ marginTop: '0.5rem' }}>You do not have administrative permission to view this page.</p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginTop: '2rem' }}>
          <button
            onClick={() => navigate('/')}
            className="btn-premium btn-premium-primary"
            style={{ padding: '12px' }}
          >
            Back to Home
          </button>
          
          <button
            onClick={handleLogout}
            className="btn-premium btn-premium-secondary"
            style={{ padding: '12px' }}
          >
            Log Out / Switch Account
          </button>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
